import Vue from 'vue';
import calculator from '@/components/calculator/calculator.vue';


import {ValidationMessages} from "@/services/validator/localization";
import {Validator} from "vee-validate";
import VeeValidate from "vee-validate";
import VueCurrencyFilter from 'vue-currency-filter';
import VueMask from 'v-mask'

import $ from 'jquery';

Vue.config.productionTip = false;

Validator.localize({en: ValidationMessages.en});
Vue.use(VeeValidate, {locale: "en"});
Vue.use($,'');
Vue.use(VueCurrencyFilter, {
    symbol: '',
    thousandsSeparator: '.',
    fractionCount: 0,
    fractionSeparator: ',',
    symbolPosition: '',
    symbolSpacing: false
});
Vue.use(VueMask);

Vue.filter('unit', function (value) {
    if (!value) return ''
    return value + ' cm'
});

new Vue({
    render(h) {
        return h(calculator, {props: {}});
    },
    methods: {}
}).$mount('#calculator-body');




